<template>
  <v-container class="fill-height login-container" fluid>
    <v-row align="center" justify="center" class="fill-height">
      <v-col cols="12" sm="8" md="5" lg="4" xl="3">
        <div class="text-center mb-8">
          <v-avatar color="white" size="80" class="mb-4 brand-logo">
            <span class="text-h4 font-weight-bold text-primary">LT</span>
          </v-avatar>
          <h1 class="text-h4 font-weight-bold text-white mb-2">Welcome Back</h1>
          <p class="text-body-1 text-white-70">Sign in to your admin account</p>
        </div>

        <v-card class="login-card pa-6" elevation="24">
          <v-form @submit.prevent="login" class="login-form">
            <v-text-field
              v-model="username"
              label="Username"
              prepend-inner-icon="mdi-account-outline"
              variant="outlined"
              density="comfortable"
              class="mb-4"
              :error="!!error"
              hide-details="auto"
            ></v-text-field>

            <v-text-field
              v-model="password"
              label="Password"
              prepend-inner-icon="mdi-lock-outline"
              :append-inner-icon="showPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
              :type="showPassword ? 'text' : 'password'"
              variant="outlined"
              density="comfortable"
              class="mb-2"
              :error="!!error"
              hide-details="auto"
              @click:append-inner="showPassword = !showPassword"
            ></v-text-field>

            <v-slide-y-transition>
              <v-alert
                v-if="error"
                type="error"
                variant="tonal"
                density="compact"
                class="mb-4 mt-4"
                closable
                @click:close="authStore.clearError()"
              >
                {{ error }}
              </v-alert>
            </v-slide-y-transition>

            <v-btn
              type="submit"
              color="primary"
              size="large"
              block
              class="mt-6 login-btn"
              :loading="loading"
              :disabled="!username || !password"
            >
              <v-icon start>mdi-login</v-icon>
              Sign In
            </v-btn>
          </v-form>
        </v-card>

        <p class="text-center text-white-50 mt-6 text-body-2">
          Lala Tacos Admin Panel
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useRouter } from 'vue-router';
import { useAuthStore } from '../stores';

const router = useRouter();
const authStore = useAuthStore();

const username = ref('');
const password = ref('');
const showPassword = ref(false);

const error = computed(() => authStore.error);
const loading = computed(() => authStore.loading);

async function login() {
  authStore.clearError();
  const result = await authStore.login(username.value, password.value);
  if (result.success) {
    router.push('/quotes');
  }
}
</script>

<style scoped>
.login-container {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  min-height: 100vh;
}

.brand-logo {
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
}

.text-white-70 {
  color: rgba(255, 255, 255, 0.7);
}

.text-white-50 {
  color: rgba(255, 255, 255, 0.5);
}

.login-card {
  border-radius: 20px !important;
  backdrop-filter: blur(10px);
  background: rgba(255, 255, 255, 0.95) !important;
}

.login-btn {
  height: 48px !important;
  font-size: 1rem !important;
  font-weight: 600 !important;
  letter-spacing: 0.5px;
  border-radius: 12px !important;
}

.login-form :deep(.v-field) {
  border-radius: 12px !important;
}

.login-form :deep(.v-field--focused) {
  border-color: #6366f1 !important;
}
</style>
